<!--
 * @Name: Entry
 * @Description: 系统入口
 * @Author: xiadongxue
 * @Date: 2021-10-20 11:35:14
 * @Editors: xiadongxue
-->
<template>
<div class="entry-wrap">
    <template v-if="(useList && useList.length) || projectList.length">
        <template v-if="useList && useList.length">
            <div class="project-title">常用系统</div>
            <div class="projectList">
                <template v-for="(item,index) in useList">
                    <div
                        v-if="index < 3"
                        @click="toEntry(item)"
                        class="project-item"
                        :key="index">
                        <div
                            class="box"
                            :style="{background: item.color || '#E60012','box-shadow': `0px 1px 1px 0px ${item.color || '#E60012'}`}">{{item.projectName[0]}}</div>
                        <div>{{item.projectName}}</div>
                    </div>
                </template>
            </div>
        </template>
        <template v-if="projectList.length">
            <div class="project-title">可用系统</div>
            <template v-for="(category,i) in categoryProjectList">
                <div
                    :key="i">
                    <div class="item">
                        <svg class="icon" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path d="M476.723 112.503L121.634 279.825a68.267 68.267 0 0 0 1.69 124.28l355.089 155.648a68.267 68.267 0 0 0 54.818 0l355.089-155.7a68.267 68.267 0 0 0 1.673-124.28l-355.09-167.252a68.267 68.267 0 0 0-58.197 0zm-325.99 229.07l355.089-167.305L860.894 341.52l-355.09 155.7-355.071-155.649zm710.11 343.773a34.133 34.133 0 0 1 28.962 61.781l-2.407 1.127-368.81 155.682a34.133 34.133 0 0 1-23.672 1.075l-2.867-1.075-368.794-155.648a34.133 34.133 0 0 1 24.064-63.83l2.492.94 355.499 150.05 355.533-150.102z" fill="#444"/><path d="M853.333 512L511.846 665.634l-341.18-153.293v55.211c0 13.466 7.749 25.651 19.713 30.925l286.19 126.976a78.797 78.797 0 0 0 35.277 8.397c12.05 0 24.081-2.8 35.294-8.397l286.498-127.25a33.74 33.74 0 0 0 19.695-30.924V512z" fill="#f56c6c" data-spm-anchor-id="a313x.7781069.0.i20" class="selected"/></svg>
                        <span>{{category.categoryName}}</span>
                    </div>
                    <div class="projectList">
                        <div
                            class="project-item"
                            v-for="(item,index) in category.list"
                            :key="index"
                            @click="toEntry(item)">
                            <div
                                class="box"
                                :style="{background: item.color ? item.color : '#E60012'}">{{item.projectName[0]}}</div>
                            <div>{{item.projectName}}</div>
                        </div>
                        <div class="line"></div>
                    </div>
                </div>
            </template>
        </template>
    </template>
    <div
        class="image-wrap"
        v-else>
        <img src="@/assets/image/empty.png" alt="">
    </div>
</div>
</template>

<script>
import {
    getProjectList
} from './api'
import {
    auth
} from '@/api'
import {
    mapGetters
} from 'vuex'
import {
    getCategoryList
} from '@/views/manage/api';
import {
    createTag
} from '@/assets/js/utils'
export default {
    name: 'entry',
    data() {
        return {
            projectList: [],
            useList: [],
            categoryList: []
        }
    },
    created() {
        this.getProjectList()
        this.toGetCategoryList()
        this.$watch('userInfo', val => {
            if (val.userId) {
                this.getUseList()
            }
        })
    },
    computed: {
        ...mapGetters(['userInfo']),
        //可用系统分类
        categoryProjectList() {
            let arr = []
            this.projectList.forEach(i => {
                let index = arr.findIndex(category => category.categoryId === i.categoryId)
                if (index != -1) {
                    arr[index].list.push(i)
                } else {
                    let item = this.categoryList.length && this.categoryList.find(item => item.categoryId === i.categoryId)
                    arr.push({
                        categoryId: i.categoryId,
                        categoryName: item ? item.categoryName : '暂无分类',
                        list: [i]
                    })
                }
            })
            return arr
        }
    },
    methods: {
        //常用系统
        getUseList() {
            let obj = localStorage.getItem('useList') ? JSON.parse(localStorage.getItem('useList')) : ''
            let list = []
            if (obj && this.userInfo && this.userInfo.userId) {
                list = obj[this.userInfo.userId] || []
            }
            this.useList = list.filter(item => {
                return this.projectList.findIndex(i => item.projectId === i.projectId) !== -1
            }).map(item => {
                return this.projectList.find(i => i.projectId === item.projectId)
            })
        },
        //获取分类
        async toGetCategoryList() {
            try {
                this.tableLoading = true;
                let {
                    code,
                    result
                } = await getCategoryList();
                if (code === 0) {
                    this.categoryList = result;
                }
            } catch (error) {
                console.log(error);
            }
        },
        //可用系统
        async getProjectList() {
            try {
                let {
                    code,
                    result
                } = await getProjectList()
                if (code === 0) {
                    this.projectList = result
                    //获取常用系统
                    this.getUseList()
                }
            } catch (error) {
                console.log(error)
            }
        },
        //跳转子系统
        toEntry(item) {
            let list = this.useList ? JSON.parse(JSON.stringify(this.useList)) : []
            let index = list.findIndex(i => i.projectId === item.projectId)
            if (index === -1) {
                list.unshift(item)
            } else {
                list.splice(index, 1)
                list.splice(0, 0, item)
            }
            localStorage.setItem('useList', JSON.stringify({
                [this.userInfo.userId]: list
            }))
            this.getUseList()
            this.toLogin(item)
        },
        //子系统登录
        async toLogin(item) {
            try {
                let {
                    code,
                    result
                } = await auth({
                    clientId: item.clientId,
                    redirectUri: item.indexUrl,
                })
                if (code === 0 && result) {
                    if (result.code) {
                        createTag(`${item.indexUrl}?code=${result.code}`)
                    }
                }
            } catch (error) {
                console.log(error)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.entry-wrap {
    .image-wrap {
        text-align: center;

        img {
            height: 50vh;
        }
    }

    .categoryWrap {
        display: flex;

        .projectList {
            margin-bottom: 20px;
        }
    }

    .project-title {
        font-size: 18px;
        margin: 10px 0;
    }

    .item {
        display: flex;
        align-items: center;
        padding: 10px;
        opacity: .7;
        svg {
            width: 20px;
            height: 20px;
            font-size: 16px;
            margin-right: 5px;
            opacity: 1;
        }
    }

    .projectList {
        display: flex;
        flex-wrap: wrap;
        margin-bottom: 60px;

        .project-item {
            width: 300px;
            height: 100px;
            margin: 10px;
            box-sizing: border-box;
            box-shadow: 0px 2px 4px 0px #ddd;
            padding: 20px;
            display: flex;
            align-items: center;
            font-size: 16px;
            font-weight: bold;
            cursor: pointer;

            &:hover {
                box-shadow: 0px 4px 12px #ddd;
            }

            .box {
                width: 60px;
                height: 60px;
                border-radius: 5px;
                text-align: center;
                line-height: 60px;
                font-size: 28px;
                color: #fff;
                margin-right: 20px;
            }
        }
    }
}
</style>
